export const PRODUCTIVITY_REASONS = [
    { value: 'aguardando_peca', label: 'Aguardando peça de reposição' },
    { value: 'em_manutencao', label: 'Em manutenção' },
    { value: 'defeito_mecanico', label: 'Defeito mecânico' },
    { value: 'defeito_eletronico', label: 'Defeito eletrônico' },
    { value: 'problema_extrusao', label: 'Problema de extrusão' },
    { value: 'upgrade', label: 'Upgrade ou modificação' },
    { value: 'fora_de_operacao', label: 'Fora de operação' },
];

export function todayISODate(now = new Date()) {
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function formatRestrictionDate(value) {
    if (!value) {
        return '—';
    }
    const [year, month, day] = String(value).slice(0, 10).split('-');
    if (!year || !month || !day) {
        return String(value);
    }
    return `${day}/${month}/${year}`;
}

export function printerIdOf(printer) {
    return printer?.printer_uuid || printer?.id || printer?.uuid || '';
}

export function openRestrictionForPrinter(restrictions, printerId) {
    if (!printerId) {
        return null;
    }
    return (restrictions || []).find((row) => row?.open && row.printer_uuid === printerId) || null;
}

/** Fim do dia local da data de encerramento. A ociosidade só conta depois disso. */
export function restrictionEndedAtMs(endedOn) {
    if (!endedOn) {
        return null;
    }
    const raw = String(endedOn).slice(0, 10);
    const ms = new Date(`${raw}T23:59:59`).getTime();
    return Number.isFinite(ms) ? ms : null;
}

export function latestRestrictionEndMs(restrictions, printerId) {
    let latest = null;
    (restrictions || []).forEach((row) => {
        if (!row || row.printer_uuid !== printerId || row.open || !row.ended_on) {
            return;
        }
        const ms = restrictionEndedAtMs(row.ended_on);
        if (ms != null && (latest == null || ms > latest)) {
            latest = ms;
        }
    });
    return latest;
}

export function anchorActivityAt(jobAt, restrictions, printerId) {
    const endAt = latestRestrictionEndMs(restrictions, printerId);
    if (endAt == null) {
        return jobAt ?? null;
    }
    if (jobAt == null) {
        return endAt;
    }
    return Math.max(Number(jobAt), endAt);
}

export function restrictionsForPrinter(restrictions, printerId) {
    return (restrictions || []).filter((row) => row?.printer_uuid === printerId);
}

export function printersAvailableForNewJob(printers, restrictions, currentPrinterId = '') {
    return (printers || []).filter((printer) => {
        const id = printerIdOf(printer);
        if (currentPrinterId && id === currentPrinterId) {
            return true;
        }
        return !openRestrictionForPrinter(restrictions, id);
    });
}

export function productivityChipLabel(restriction) {
    const reason = restriction?.reason_label || 'Não produtiva';
    return `Não produtiva · ${reason}`;
}
